import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/user_analysis.png";
import { StaticImage } from "gatsby-plugin-image";

const Useranalysisyeppy = () => {
  return (
    <div
      className="useranalysis_yeppy p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>User Analysis</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              In this section, we'll explore three "User Personas" to better
              understand their diverse needs, goals, and challenges. This
              detailed analysis will guide us in tailoring our product "Yeppy"
              to effectively address the unique requirements of each user type.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="user_main">
              <div className="user_analysis_box">
                <div className="user_analsis_flex">
                  <div className="user_analysis_img">
                    <StaticImage
                      src="../../../images/case-studies/yeppy/user_report_img.png"
                      alt="TekRevol"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["png"]}
                      width={140}
                    />
                  </div>
                  <div className="user_analysis_content">
                    <h6>
                      <strong>User Persona 1:</strong>Housewives
                    </h6>
                    <div className="user_analysis_down">
                      <h6>Background:</h6>
                      <ul>
                        <li>
                          <strong>Name:</strong> Aisha Khan
                        </li>
                        <li>
                          <strong>Location:</strong> Dubai, UAE
                        </li>
                        <li>
                          <strong>Marital Status:</strong> Married
                        </li>
                        <li>
                          <strong>Occupation:</strong> Homemaker
                        </li>
                        <li>
                          <strong>Family:</strong> Aisha has two young children,
                          ages 3 and 5.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user_analysis_second_content">
                <h4>Goals and Needs</h4>
                <ul>
                  <li>
                    <strong>Convenience:</strong> Aisha values convenience in
                    managing her household tasks, especially grocery shopping,
                    as it's challenging to go outside with her young children.
                  </li>
                  <li>
                    <strong>Time Efficiency:</strong> She wants to save time and
                    energy by finding a solution that reduces the need for
                    physically going to the store.
                  </li>
                  <li>
                    <strong>Quality and Budgeting:</strong> Aisha seeks a
                    cost-effective way to purchase quality groceries and
                    household items for her family.
                  </li>
                  <li>
                    <strong>Safety and Security:</strong> Ensuring the safety of
                    her family is her top priority.
                  </li>
                </ul>
                <h4>Challenges</h4>
                <ul>
                  <li>
                    Aisha faces difficulties in going to the grocery store due
                    to her young children.
                  </li>
                  <li>
                    She often finds it challenging to manage her household tasks
                    efficiently while taking care of her kids. Keeping her
                    family's expenses within the budget can be a struggle.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="user_main">
              <div className="user_analysis_box">
                <div className="user_analsis_flex">
                  <div className="user_analysis_img">
                    <StaticImage
                      src="../../../images/case-studies/yeppy/user_2.png"
                      alt="TekRevol"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["png"]}
                      width={139}
                    />
                  </div>
                  <div className="user_analysis_content">
                    <h6>
                      <strong>User Persona 2:</strong>Professionals
                    </h6>
                    <div className="user_analysis_down">
                      <h6>Background:</h6>
                      <ul>
                        <li>
                          <strong>Name:</strong> Makhdoom
                        </li>
                        <li>
                          <strong>Age:</strong> 30
                        </li>
                        <li>
                          <strong>Marital Status:</strong> Single
                        </li>
                        <li>
                          <strong>Occupation:</strong> Software Engineer
                        </li>
                        <li>
                          <strong>Location:</strong> Qatar
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user_analysis_second_content">
                <h4>Goals and Needs</h4>
                <ul>
                  <li>
                    <strong>Efficiency and Time Savings:</strong> Makhdoom
                    values his time and seeks an app that streamlines tasks like
                    transportation, ordering meals, and paying bills.
                  </li>
                  <li>
                    <storng>Security:</storng> Ensuring the safety of his
                    financial transactions and personal data is a top priority.
                  </li>
                </ul>
                <h4>Challenges</h4>
                <ul>
                  <li>
                    <strong>Juggling Work Responsibilities:</strong> Makhdoom
                    often faces challenges in balancing his work
                    responsibilities with daily tasks, leaving limited time for
                    personal matters.
                  </li>
                  <li>
                    <strong>Finding Reliable and Quick Transportation:</strong>
                    He needs a reliable transportation solution for both his
                    daily commute and occasional trips.
                  </li>
                  <li>
                    <strong>Managing Expenses:</strong> Makhdoom struggles to
                    manage his expenses efficiently and stay updated on bills.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="user_main">
              <div className="user_analysis_box">
                <div className="user_analsis_flex">
                  <div className="user_analysis_img">
                    <StaticImage
                      src="../../../images/case-studies/yeppy/user_3.png"
                      alt="TekRevol"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["png"]}
                      width={139}
                    />
                  </div>
                  <div className="user_analysis_content">
                    <h6>
                      <strong>User Persona 3:</strong> Business Owner
                    </h6>
                    <div className="user_analysis_down">
                      <h6>Background:</h6>
                      <ul>
                        <li>
                          <strong>Name:</strong> Sara
                        </li>
                        <li>
                          <strong>Age:</strong> 40
                        </li>
                        <li>
                          <strong>Marital Status:</strong> Single
                        </li>
                        <li>
                          <strong>Occupation:</strong> Small Business Owner
                          (Restaurant)
                        </li>
                        <li>
                          <strong>Location:</strong> UAE
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user_analysis_second_content">
                <h4>Goals and Needs</h4>
                <ul>
                  <li>
                    <strong>Business Growth:</strong> Sarah is keen to expand
                    her restaurant's customer base and reach a larger audience.
                  </li>
                  <li>
                    <strong>Operational Efficiency:</strong> She needs tools for
                    order management and inventory control.
                  </li>
                  <li>
                    <strong>Networking and Promotion:</strong>
                    Sarah wants to connect with other local business owners for
                    collaborations and promotion.
                  </li>
                </ul>
                <h4>Challenges</h4>
                <ul>
                  <li>
                    <strong>Competition and Standing Out:</strong> Sarah's
                    restaurant faces stiff competition, and she needs innovative
                    ways to stand out in the market.
                  </li>
                  <li>
                    <strong>Managing Daily Operations:</strong> Sarah struggles
                    with managing daily restaurant operations, including order
                    processing and inventory management.
                  </li>
                  <li>
                    <strong>Establishing an Online Presence:</strong> She aims
                    to establish a strong online presence and form local
                    partnerships to drive her restaurant's growth.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Useranalysisyeppy;
